(function(){
    'use strict';
    angular.module('app')
    .controller('SummaryDetailsController', SummaryDetailsController)
    SummaryDetailsController.$inject = [
        '$routeParams',
        '$scope',
        'SummaryTableService',
        '$window',
        'AffiliateService'
    ]
    
    function SummaryDetailsController ($routeParams,$scope,SummaryTableService,$window,AffiliateService){
        const vm = this;
        vm.paramsId = $routeParams.id;
        $scope.goBack = function(){
            $window.history.back();
        }
        
        $scope.financialSummary = function(){
            $location.path('/affiliates-sales/summary/'+vm.paramsId)
        }

        init();

        function init(){
            getCompanyDetailsSummary();
            $scope.tableData = new SummaryTableService().tableData
        }

        function getCompanyDetailsSummary(){
            AffiliateService.getCompanyDetails(
                res=>{
                    vm.company = res;
                },
                err=>{
                    console.log(err)
                },vm.paramsId
            )
        }
    };
})()


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/SummaryDetailsController.js